import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BrowserComponent from './BrowserComponent';
import { Modal, Paper } from '@mui/material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';
import { Search } from '@mui/icons-material';
import { useEffect } from 'react';

export const BrowserContainer = ({
  selectedValue,
  label,
  columns,
  sortingColumns,
  options,
  optionsLoading,
  loadOptions,
  filterColumns,
  hiddenColumnNames,
  idColumnName,
  valueColumnName,
  onChange,
  onTextFieldChange,
  onBlur,
  textFieldDefaultValue,
  error,
  helperText,
  columnExtensions,
  textFieldDisabled,
  iconDisabled,
  iconHidden,
  textFieldId,
  required,
  hasCustomIcons,
  customEndIcons,
  isBrowserOpen,
  setIsBrowserOpen,
  minimumSearchLength,
  hasSimpleValue
}) => {
  const [open, setOpen] = useState(false);
  const [singleSelectedData, setSingleSelectedData] = useState(selectedValue);

  useEffect(() => {
    if (hasSimpleValue) {
      if (singleSelectedData !== selectedValue) setSingleSelectedData(selectedValue);
    } else {
      if (singleSelectedData.value !== selectedValue.value) setSingleSelectedData(selectedValue);
    }
  }, [selectedValue, singleSelectedData, hasSimpleValue]);

  return (
    <>
      <TextField
        fullWidth
        name='value'
        value={textFieldDefaultValue ? textFieldDefaultValue : hasSimpleValue ? singleSelectedData ?? '' : singleSelectedData?.value ?? ''}
        disabled={textFieldDisabled}
        label={label}
        onChange={onTextFieldChange}
        onBlur={onBlur}
        error={error}
        id={textFieldId}
        helperText={helperText}
        required={required}
        endAdornment={
          !iconHidden ? (
            hasCustomIcons ? (
              customEndIcons
            ) : (
                <IconButton disabled={iconDisabled} color='primary' size='tiny' variant='text' onClick={() => setOpen(true)}>
                  <Search />
                </IconButton>
            )
          ) : undefined
        }
      />
      <Modal onClose={hasCustomIcons ? () => setIsBrowserOpen(false) : () => setOpen(false)} open={hasCustomIcons ? isBrowserOpen : open}>
        <Paper sx={{ p: 3 }}>
          <BrowserComponent
            onClose={hasCustomIcons ? () => setIsBrowserOpen(false) : () => setOpen(false)}
            setSingleSelectedData={setSingleSelectedData}
            columns={columns}
            sortingColumns={sortingColumns}
            optionsList={options}
            optionsLoading={optionsLoading}
            loadOptions={loadOptions}
            filterColumns={filterColumns}
            hiddenColumnNames={hiddenColumnNames}
            idColumnName={idColumnName}
            valueColumnName={valueColumnName}
            onChange={onChange}
            columnExtensions={columnExtensions}
            minimumSearchLength={minimumSearchLength}
            hasSimpleValue={hasSimpleValue}
          />
        </Paper>
      </Modal>
    </>
  );
};

BrowserContainer.propTypes = {
  selectedValue: PropTypes.any,
  label: PropTypes.string.isRequired,
  filterColumns: PropTypes.array,
  columns: PropTypes.array.isRequired,
  sortingColumns: PropTypes.array,
  hiddenColumnNames: PropTypes.array,
  options: PropTypes.object,
  optionsLoading: PropTypes.bool,
  loadOptions: PropTypes.func,
  idColumnName: PropTypes.string.isRequired,
  valueColumnName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func,
  onBlur: PropTypes.func,
  textFieldDefaultValue: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  columnExtensions: PropTypes.array,
  textFieldDisabled: PropTypes.bool.isRequired,
  textFieldId: PropTypes.string,
  iconDisabled: PropTypes.bool,
  iconHidden: PropTypes.bool,
  required: PropTypes.bool,
  hasCustomIcons: PropTypes.bool,
  customEndIcons: PropTypes.node,
  isBrowserOpen: PropTypes.bool,
  setIsBrowserOpen: PropTypes.func,
  searchLength: PropTypes.number,
  hasSimpleValue: PropTypes.bool,
  minimumSearchLength: PropTypes.number
};

export default BrowserContainer;
